
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as g8YJNmd5OZoc6r4CuUN6fnD9VC0gfG6gBOQ7c22Og2FUMeta } from "/codebuild/output/src350844999/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexF7_45WYmCpHwbVjziOz3rYcFnBfGh8FMBwfweLnx0gtvAMeta } from "/codebuild/output/src350844999/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchRqJcWahjytdkJ3o_453gr_6aB5mU7RqPZLrywMcuGJwCgMeta } from "/codebuild/output/src350844999/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexjX98QY6YIOanDPiA7GKFWt64xpxTX55csWptmQMDY5UMeta } from "/codebuild/output/src350844999/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93q1J28xHILa5kB904KhAmUeMXXdz0fWYjC49BrZDhlGoMeta } from "/codebuild/output/src350844999/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexA1FJY2Fn2TJRkOJ5hFZUvtwHKuRLMcpy6pF8Nyr_upAMeta } from "/codebuild/output/src350844999/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93M7fEGfo_uJxYf5sJM7G4yW6ljIZEJwwonQAzVUbueg8Meta } from "/codebuild/output/src350844999/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexTAdXioUTalxU4OcQmgIzHBdRjiUKdk3BMB9rk7H_bZwMeta } from "/codebuild/output/src350844999/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93lKORbtt_45tb3YdYtvtOT6T7wrry2VglQ7qnUd_lq6LiwMeta } from "/codebuild/output/src350844999/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as index72nGyevRF4TLLQ7BAZ1XOc7cnV0Nb_45fqTaUtHy1kIT0Meta } from "/codebuild/output/src350844999/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexcPOquaP8E2onjmtSO5dfrT9gX4_tsxKo4pgh6uFZtjQMeta } from "/codebuild/output/src350844999/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src350844999/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src350844999/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src350844999/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src350844999/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src350844999/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexA1FJY2Fn2TJRkOJ5hFZUvtwHKuRLMcpy6pF8Nyr_upAMeta || {},
    component: () => import("/codebuild/output/src350844999/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src350844999/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexTAdXioUTalxU4OcQmgIzHBdRjiUKdk3BMB9rk7H_bZwMeta || {},
    component: () => import("/codebuild/output/src350844999/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src350844999/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: index72nGyevRF4TLLQ7BAZ1XOc7cnV0Nb_45fqTaUtHy1kIT0Meta || {},
    component: () => import("/codebuild/output/src350844999/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexcPOquaP8E2onjmtSO5dfrT9gX4_tsxKo4pgh6uFZtjQMeta || {},
    component: () => import("/codebuild/output/src350844999/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]